import { CheckBox2, Td2, Tr2 } from 'bambooo';
/**
 * One right row in the role-rights table (v2). Carries the right id + raw key
 * (for filtering) and an access checkbox; the visible icon/label is set via
 * {@link setDisplay}.
 */
export class RoleRightEntry extends Tr2 {
    /**
     * Constructor
     * @param {RoleRightListWidget} element
     */
    constructor(element) {
        super();
        this._readonly = false;
        this._rightId = 0;
        this._rightKey = '';
        this._searchText = '';
        this.appendTo(element.getTable().getTbody());
        this._tdName = new Td2({});
        this._tdName.appendTo(this);
        const tdCA = new Td2({});
        tdCA.appendTo(this);
        this._checkAccess = new CheckBox2({});
        this._checkAccess.appendTo(tdCA);
    }
    /**
     * Set read only
     * @param {boolean} readonly
     */
    setReadOnly(readonly) {
        this._readonly = readonly;
        this._checkAccess.setReadOnly(readonly);
    }
    /**
     * Is read only
     * @return {boolean}
     */
    isReadOnly() {
        return this._readonly;
    }
    /**
     * Remove
     */
    remove() {
        this._element.remove();
    }
    /**
     * Keep id + raw key (for filtering). Label/icon set via setDisplay().
     * @param {RightEntry} right
     */
    setRight(right) {
        this._rightId = right.id;
        this._rightKey = right.key;
    }
    /**
     * Configure the visible row: icon, label, search text, optional indent.
     * @param {string} iconClasses
     * @param {string} label
     * @param {string} searchText
     * @param {boolean} indent
     */
    setDisplay(iconClasses, label, searchText, indent = false) {
        this._searchText = searchText.toLowerCase();
        const padding = indent ? 'padding-left: 36px;' : 'padding-left: 12px;';
        const td = this._tdName.getElement();
        td.empty();
        td.attr('style', padding);
        td.append(`<i class="${iconClasses} mr-2" style="width: 18px; text-align: center;"></i>` +
            `<span>${label}</span>`);
    }
    /**
     * Return the raw right key
     * @return {string}
     */
    getRightKey() {
        return this._rightKey;
    }
    /**
     * Return the lower-cased combined search text
     * @return {string}
     */
    getSearchText() {
        return this._searchText;
    }
    /**
     * Show / hide the row
     * @param {boolean} visible
     */
    setVisible(visible) {
        if (visible) {
            this._element.show();
        }
        else {
            this._element.hide();
        }
    }
    /**
     * Return the right id
     * @return {number}
     */
    getRightId() {
        return this._rightId;
    }
    /**
     * Set checked
     * @param {boolean} checked
     */
    setChecked(checked) {
        this._checkAccess.setChecked(checked);
    }
    /**
     * Return the checked access
     * @return {boolean}
     */
    getChecked() {
        return this._checkAccess.isChecked();
    }
}
